import UpdateOrganizer from './UpdateOrganizer'
export default UpdateOrganizer
